module.exports = __webpack_public_path__ + "static/pic04-efb9bf477fb3ce34944de8a927d31691.png";